import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ProductService } from '../../../../services-http/product/product.service'; 
import Swal from 'sweetalert2';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-create-product',
  templateUrl: './create-product.component.html',
  styleUrls: ['./create-product.component.scss']
})
export class CreateProductComponent implements OnInit {

   productForm: FormGroup;
   variatid:any = ''

  constructor(
    private fb: FormBuilder,
    private ps:ProductService,
    private route: ActivatedRoute
  ) {

   this.variatid=this.route.snapshot.paramMap.get('variantid');
  }

  ngOnInit() {

    this.productForm = this.fb.group({
      shortname: [''],
      longName: [''],
      productType: [''],
      description: [''],
      ageFrom: [''],
      ageTo: ['']
    });


    if(this.variatid>0){
      this.ps.getSpecificProduct(this.variatid)
        .subscribe((res:any)=>{

          this.productForm.patchValue({
            shortname: res.varshortname,
            longName: res.varlongname,
            productType: res.classification,
            description: res.description,
            ageFrom: res.age_from,
            ageTo: res.age_to
          });

          res.prod[0].option.forEach(row => {
            this.options.push({
              optionName: row.optionName, 
              grossPremium: row.grossprem
            });
        
          });

          res.option.forEach(row => {
            this.benefits.push(
              {optionName:row.product_option.optionName,
              benefitName: row.benefits.benefitDescription, 
              coverage: row.coverage, 
              category: row.beneficiary 
            });
          });

          res.payment_list_rates.forEach(row=>{
            this.paymentLists.push({
              paymentList:row.paymentListNo,
              rate:row.rate
            });
          });
      });
    }
  }



 onSubmit() {

    let data = {
      product:this.productForm.value,
      options: this.options,
      benefits: this.benefits,
      paymentLists: this.paymentLists 
    };

    this.ps.createProduct(data)
      .subscribe((res:any) => {

        Swal.fire({
          title: 'Success',
          text: res.msg,
          confirmButtonText: 'OK',
          type: 'success'
        })
    },error=>{


      let err=error.status == 0?{msg: 'Something went wrong.'}: error.error ;
      let msg='';
      
      Object.keys(err).forEach(function(key){
        msg+=err[key]+'</br>';
      })
        
 
      Swal.fire({
        title: 'Error',
        text: msg,
        type: 'warning',
        confirmButtonText: 'OK',

      });
    }
  );
    

  }


  onGrossPremiumInput(event: any, index: number) {
  const rawValue = event.target.value.replace(/,/g, ''); // remove commas
  this.options[index].grossPremium = rawValue;
}



// Dynamic arrays for tables
  options:any = [{ optionName: '', grossPremium: null }];
  benefits:any = [{optionName:'', benefitName: '', coverage: null, category: '' }];
  paymentLists:any = [{ paymentList: '', rate: null }];

  // Option table methods
  addOption() {
    this.options.push({ optionName: '', grossPremium: null });
  }

  removeOption(index: number) {
    this.options.splice(index, 1);
  }

  // Benefit table methods
  addBenefit() {
    this.benefits.push({ optionName:'',benefitName: '', coverage: null, category: '' });
  }

  removeBenefit(index: number) {
    this.benefits.splice(index, 1);
  }

  // Payment List table methods
  addPaymentList() {
    this.paymentLists.push({ paymentList: '', rate: null });
  }

  removePaymentList(index: number) {
    this.paymentLists.splice(index, 1);
  }
}
